// Self-contained data for the Berguia Law concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/02_Berguia_Law (research snapshot 2026-08-21).
// Do not add claims beyond what the dossier supports — see Cautions in that dossier.
export const BIZ = {
  name: "Berguia Law",
  fullName: "The Law Office of Atty. Paul Jordan T. Berguia",
  tagline: "Civil, Criminal & Family Law Representation in Davao City",
  address: "Suite 104, JMS Building, 88 Maya Street, Ecoland, Matina, Davao City",
  phone: "+639198294681",
  phoneDisplay: "+63 919 829 4681",
  linkedin: "https://www.linkedin.com/in/paul-jordan-berguia-7534921b6",
  mapEmbed: "https://www.google.com/maps?q=JMS+Building+88+Maya+Street+Ecoland+Matina+Davao+City&output=embed",
};

export const PRACTICE_AREAS = [
  { title: "Civil Law", text: "Representation and legal support in civil matters." },
  { title: "Criminal Law", text: "Criminal defense representation." },
  { title: "Family Law", text: "Family-related legal matters, including annulment and related concerns raised by the local community." },
  { title: "General Legal Services", text: "General attorney services for individuals in Davao City." },
];

export const JOURNEY = [
  { year: "Before law", title: "Registered Nurse", text: "I started in healthcare as a Registered Nurse, before moving into legal work." },
  { year: "", title: "Paralegal", text: "I worked as a paralegal, building a working knowledge of legal practice from the ground up." },
  { year: "", title: "Associate Attorney", text: "I practiced as an associate attorney, developing experience across case work." },
  { year: "2019–2020", title: "Admitted to the Bar", text: "I passed the 2019 Bar Examinations and was admitted to the Philippine Bar in July 2020." },
  { year: "Since", title: "Berguia Law, Davao City", text: "I established my own practice at JMS Building, Ecoland, Matina, Davao City." },
];

export const CONSULT_STEPS = [
  { n: "1", title: "Reach Out", text: "Call me directly to start the conversation." },
  { n: "2", title: "Share General Details", text: "Briefly describe your situation — no need for sensitive details up front." },
  { n: "3", title: "Schedule a Consultation", text: "Set a time to discuss your matter at the Davao office." },
  { n: "4", title: "Discuss Your Situation", text: "Talk through your concern and what the next steps could look like." },
];

// Only one individually-readable public recommendation was recovered (Reddit, r/davao, 2026-07-26).
// The larger review pool (5.0★, 76 current listing) exists in aggregate only — do not invent review bodies.
export const REVIEW = {
  rating: "5.0",
  reviewCountLabel: "76 reviews in current public listings",
  quote: "Recommended Atty. Paul Jordan Berguia / Berguia Law when a fellow r/davao user asked for a good annulment lawyer — told them to look him up.",
  source: "Reddit, r/davao",
  date: "July 2026",
  sourceUrl: "https://www.reddit.com/r/davao/comments/1qfq7xl/lf_annulment_lawyer_any_suggestion/",
};
